import React from 'react';
import './spinner.css';

function Spinner() {
    return (
        <div className="lds-hourglass"></div>
    )
}

export default Spinner;
